





import Vue, { PropType } from 'vue'

type ClassesCSS = Record<string, boolean>

interface ValidadorInjetado {
  [key: string]: boolean | null;
}

interface Data {
  validadoresInjetados: ValidadorInjetado;
  camposSaoValidos: boolean;
}

interface Methods {
  registradorDeValidador: (idDoValidador: number) => void;
  atualizadorDeValorDoValidador: (idDoValidador: number, valorDaValidacao: boolean) => void;
  desregistradorDeValidador: (idDoValidador: number) => void;
  validadorDeTodosOsItens: () => boolean;
}

interface Computed {
  classes: ClassesCSS;
}

interface Props {
  value: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'PFormulario',

  provide () {
    return {
      registradorDeValidador: this.registradorDeValidador,
      desregistradorDeValidador: this.desregistradorDeValidador,
      atualizadorDeValorDoValidador: this.atualizadorDeValorDoValidador
    }
  },

  props: {
    value: {
      type: Boolean as PropType<boolean>,
      required: true
    }
  },

  computed: {
    classes (): ClassesCSS {
      return {
        'formulario--valido': this.value,
        'formulario--invalido': !this.value
      }
    }
  },

  data () {
    return {
      validadoresInjetados: {} as ValidadorInjetado,
      camposSaoValidos: false as boolean
    }
  },

  methods: {
    registradorDeValidador (idDoValidador: number): void {
      const id = idDoValidador.toString()
      this.$set(this.validadoresInjetados, id, null)
    },

    atualizadorDeValorDoValidador (idDoValidador: number, valorDaValidacao: boolean): void {
      const id = idDoValidador.toString()
      this.$set(this.validadoresInjetados, id, valorDaValidacao)
    },

    desregistradorDeValidador (idDoValidador: number): void {
      const id = idDoValidador.toString()
      this.$delete(this.validadoresInjetados, id)
    },

    validadorDeTodosOsItens (): boolean {
      function verdadeiroOuNulo (valor: unknown): boolean {
        return valor === true || valor === null
      }

      const valoresDosValidadoresInjetados = Object.values(this.validadoresInjetados)
      const resultado = valoresDosValidadoresInjetados.every(verdadeiroOuNulo)
      return resultado
    }
  },
  watch: {
    validadoresInjetados: {
      deep: true,
      handler (): void {
        const resultado = this.validadorDeTodosOsItens()
        this.camposSaoValidos = resultado
        this.$emit('input', resultado)
      }
    }
  }
})
